/* eslint-disable */
import _ from 'lodash';

const getters = {
  listProducts: state => state.listProducts || [],
  listInventaireProducts: state => state.listInventaireProducts || [],
  listInventaireProductsByFamily: state => _.mapValues(_.groupBy(state.listProducts, 'family'), x => _.orderBy(x, 'nameDisplayed'))
   || [],
  inventaireHead: state => state.inventaireHead || {},
  listInventaireProductsAverageQty: state => state.listInventaireProductsAverageQty || {},
};

export default getters;
